module.exports = __webpack_public_path__ + "img/cairos.914bf38f.png";